import Vue from 'vue';
import $http from '../utils/http';
import * as Cookies from 'js-cookie';

Vue.use(Cookies);

const impersonateChannel = (token, contentProviderID, reason) => {
  const header = token
    ? { authorization: token, 'x-company-header': Cookies.get('companyID') }
    : null;
  return $http('/support/impersonate-channel', { contentProviderID, reason }, 'POST', header);
};

const endSupportAccess = (token, supportLogId) => {
  const header = token
    ? { authorization: token, 'x-company-header': Cookies.get('companyID') }
    : null;
  return $http('/support/end', { supportLogId }, 'POST', header);
};

export { impersonateChannel, endSupportAccess };
